var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("li", [
    _vm.booking.campaign
      ? _c(
          "div",
          { staticClass: "w-full campaign-banner" },
          [
            _c("div", [
              _c("i", { staticClass: "fa fa-lg fa-clone margin-r-1" }),
              _vm._v(" Part of campaign: " + _vm._s(_vm.booking.campaign.name)),
            ]),
            _vm._v(" "),
            _vm.$userIsAdmin
              ? _c(
                  "router-link",
                  {
                    staticClass: "margin-r-1",
                    attrs: {
                      to: {
                        name: "campaign.edit",
                        params: { id: _vm.booking.campaign.id },
                      },
                    },
                  },
                  [
                    _c("span", [
                      _vm._v("View Campaign "),
                      _c("i", { staticClass: "fa fa-chevron-right" }),
                    ]),
                  ]
                )
              : _vm._e(),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "list-item" },
      [
        _c(
          "router-link",
          { staticClass: "list-item__container", attrs: { to: _vm.link } },
          [
            _c("div", { staticClass: "list-item__content" }, [
              _c(
                "div",
                { staticClass: "list-item__header" },
                [
                  _c(
                    "div",
                    { staticClass: "list-item__pills" },
                    [_vm._t("pill")],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "list-item__title",
                      attrs: { "data-test-id": "hasTitle" },
                    },
                    [
                      _vm._t("title", function () {
                        return [_c("h3", [_vm._v(_vm._s(_vm.bookingName))])]
                      }),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _vm._t("bids"),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "list-item__category" },
                    [_vm._t("categories")],
                    2
                  ),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "list-item__meta list-meta" },
                [
                  _c(
                    "div",
                    { staticClass: "list-item__status w-full" },
                    [_vm._t("status")],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "meta-item",
                    { attrs: { icon: "map-marker", label: false } },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm._f("nullable")(_vm.bookingStateOrOnline)) +
                          "\n          "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.bookingAppearanceInPerson
                    ? _c("meta-date", {
                        attrs: { booking: _vm.booking, icon: "calendar" },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.bookingAppearanceOnline
                    ? _c("meta-due", {
                        attrs: { booking: _vm.booking, icon: "globe" },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.bookingAppearanceOffer
                    ? _c("meta-offer-date", {
                        attrs: { booking: _vm.booking, icon: "calendar" },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._t("meta"),
                  _vm._v(" "),
                  _vm._t("client", function () {
                    return [
                      _vm.$userIsManager
                        ? _c(
                            "meta-item",
                            {
                              attrs: {
                                "is-name": true,
                                icon: "user",
                                label: false,
                              },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.bookingTalentNames) +
                                  "\n            "
                              ),
                            ]
                          )
                        : _vm.$userIsNotClient &&
                          _vm.bookingClientCompanyAndName
                        ? _c(
                            "meta-item",
                            {
                              attrs: {
                                "is-name": true,
                                icon: "user",
                                label: false,
                              },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.bookingClientCompanyAndName) +
                                  "\n            "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]
                  }),
                  _vm._v(" "),
                  _vm.$userIsAdmin &&
                  _vm.booking.latest_note &&
                  _vm.booking.latest_note.text
                    ? _c(
                        "div",
                        { staticClass: "w-full flex justify-end spacer-t-2" },
                        [
                          _c("div", { staticClass: "comment spacer-t-2" }, [
                            _c("div", {
                              staticClass: "comment__body",
                              domProps: {
                                innerHTML: _vm._s(_vm.booking.latest_note.text),
                              },
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "comment__meta" }, [
                              _c("div", { staticClass: "comment__author" }, [
                                _vm._v(
                                  _vm._s(_vm.booking.latest_note.user.name)
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "comment__date" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("date")(
                                      _vm.latestNoteDateCreated,
                                      _vm.$user.date_format_preference
                                    )
                                  )
                                ),
                              ]),
                            ]),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ],
                2
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "list-item__values" }, [
              _vm.$slots.hero
                ? _c(
                    "div",
                    { staticClass: "list-item__hero" },
                    [_vm._t("hero")],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.$userIsAdmin
                ? _c(
                    "div",
                    { staticClass: "list-item__admin" },
                    [_vm._t("admin")],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.$userIsAdmin
                ? _c(
                    "div",
                    { staticClass: "list-item__admin" },
                    [
                      _vm._t("admin"),
                      _vm._v(" "),
                      _c(
                        "meta-item",
                        {
                          attrs: { "data-test-id": "requestDate" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "key",
                                fn: function () {
                                  return [_vm._v("Created:")]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            false,
                            863894288
                          ),
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm._f("date")(
                                  _vm.bookingDateCreated,
                                  _vm.$user.date_format_preference
                                )
                              ) +
                              "\n          "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "meta-item",
                        {
                          attrs: { "data-test-id": "requestID" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "key",
                                fn: function () {
                                  return [_vm._v("Request ID:")]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            false,
                            510949548
                          ),
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(this.booking.id) +
                              "\n          "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      !_vm.$vlastMode
                        ? [
                            _c("div", { staticClass: "spacer-y-1" }),
                            _vm._v(" "),
                            _c(
                              "meta-item",
                              {
                                attrs: {
                                  "data-test-id": "conversionProbability",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "key",
                                      fn: function () {
                                        return [
                                          _vm._v("Conversion Probability:"),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  false,
                                  1267897445
                                ),
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm._f("nullable")(
                                        this.booking.conversion_probability
                                      )
                                    ) +
                                    "\n            "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "meta-item",
                              {
                                attrs: { "data-test-id": "pipelineStatus" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "key",
                                      fn: function () {
                                        return [_vm._v("Pipeline Status:")]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  false,
                                  209806790
                                ),
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm._f("nullable")(
                                        _vm._f("sentenceCase")(
                                          this.booking.pipeline_status
                                        )
                                      )
                                    ) +
                                    "\n            "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "meta-item",
                              {
                                attrs: { "data-test-id": "estCloseDate" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "key",
                                      fn: function () {
                                        return [_vm._v("Est. Close Date:")]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  false,
                                  2134809182
                                ),
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm._f("nullable")(
                                        _vm._f("dateTimezone")(
                                          this.booking.est_close_date,
                                          this.$user.timezone
                                        )
                                      )
                                    ) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "meta-item",
                        {
                          attrs: { "data-test-id": "assignedAdmin" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "key",
                                fn: function () {
                                  return [_vm._v("Admin:")]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            false,
                            2343926431
                          ),
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.bookingAssignedAdmin) +
                              "\n          "
                          ),
                        ]
                      ),
                    ],
                    2
                  )
                : _vm.$userIsManager
                ? _c(
                    "div",
                    { staticClass: "list-item__admin" },
                    [
                      _c(
                        "meta-item",
                        {
                          attrs: { "data-test-id": "requestID" },
                          scopedSlots: _vm._u([
                            {
                              key: "key",
                              fn: function () {
                                return [_vm._v("Request ID:")]
                              },
                              proxy: true,
                            },
                          ]),
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(this.booking.id) +
                              "\n          "
                          ),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ]),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }